import type { Order, OrderAnalytic } from '@talos/kyoko';
import { TradePredictions } from './TradePredictions';

interface TradePredictionsWrapperProps {
  order: Order;
  isOrderMultiLeg?: boolean;
  latestAnalytics: Record<number, OrderAnalytic> | undefined;
}

export function TradePredictionsWrapper({ order, isOrderMultiLeg, latestAnalytics }: TradePredictionsWrapperProps) {
  if (isOrderMultiLeg || !latestAnalytics) {
    return null;
  }

  return <TradePredictions order={order} latestAnalytics={latestAnalytics} />;
}
